module.exports = __webpack_public_path__ + "static/product-l0980-olive-drab-cb59cd807196be0b5b35795f3a47b87e.png";